import { ClientType } from "../enums/clientTypeEnum";
import { OrderPageType } from "./orderPageType";

export interface OrderStatus{
    id: string;
    createdAt: string;
    updatedAt: string | null;
    deletedAt: string | null;
    name: string;
    sortOrder: number;
    showInMenu: boolean;
    clientTypes: ClientType[] | null,
    orderPageType: OrderPageType | null;
    ableToExportOrdersInStatus: boolean;
    axCallbackStatus: boolean;
    requiresCatalogApproval: boolean;
    catalogCallbackStatus: boolean;
    catalogDeniedStatus: boolean;
    orderFinalized: boolean;
    deliveredStatus: boolean;
    goodsInWarehouseStatus: boolean;
}

export const defaultOrderStatus: OrderStatus = {
    id: "",
    createdAt: "",
    updatedAt: null,
    deletedAt: null,
    name: "",
    sortOrder: 0,
    showInMenu: false,
    clientTypes: null,
    orderPageType: null,
    ableToExportOrdersInStatus: false,
    axCallbackStatus: false,
    requiresCatalogApproval: false,
    catalogCallbackStatus: false,
    catalogDeniedStatus: false,
    orderFinalized: false,
    deliveredStatus: false,
    goodsInWarehouseStatus: false
}